<template>
  <div
      class="cws-container blog-wrapper"
  >

    <div>
      <b-row>
        <b-col
            md="12"
            lg="12"
        >
          <b-card
              title="SIQ Импорт"
              class="mb-3"
              border-variant="primary"
          >
            <b-card-text>
              Загрузка SIQ-файла для импорта песен
            </b-card-text>

            <b-form-group
                label="SIQ-Файл"
                label-for="siq-file"
            >
              <b-button
                  variant="outline-primary"
                  @click="$refs.refInputUploadFile.click()"
              >
                <input
                    ref="refInputUploadFile"
                    type="file"
                    class="d-none"
                    id="siq-file"
                    @input="inputSiqFileRenderer"
                />
                <span class="d-none d-sm-inline">Upload</span>
                <feather-icon
                    icon="EditIcon"
                    class="d-inline d-sm-none"
                />
              </b-button>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>

    </div>

    <!-- content -->
    <div class="blog-detail-wrapper">
      <b-row  v-if="playlistDetail">
        <!-- blogs -->
        <b-col cols="12">
          <b-overlay
              :show="isLoadingPlaylist"
              rounded="sm"
          >
            <b-card
                _img-top
                _img-alt="Постер"
                _:title="`${playlistDetail.title}`"
            >
              <h1 class="d-flex">{{ playlistDetail.title }}
                <b-button
                    v-if="playlistDetail.url"
                    :href="playlistDetail.url"
                    variant="warning"
                    class="btn-icon ml-1"
                    size="sm"
                >
                  <feather-icon icon="CastIcon"/>
                </b-button>
              </h1>

              <b-row>
                <div
                    class="blog-content"
                    v-html="playlistDetail.description"
                />
              </b-row>

              <b-row>
                <b-col
                    cols="12"
                    md="12"
                    class="d-flex align-items-center justify-content-center mb-2 mb-md-0"
                >


                  <b-card
                      :title="'Плейлист: ' + playlistDetail.title"
                      class="col-md-12 col-12"
                  >
                    <b-overlay
                        :show="isLoadingPlaylist"
                        rounded="sm"
                    >
                      <b-row>
                        <b-col md="12">
                          <b-tabs
                              pills
                          >
                            <!-- Tab: Песни (таблица) -->
                            <b-tab>
                              <template #title>
                                <feather-icon
                                    icon="Share2Icon"
                                    size="16"
                                    class="mr-0 mr-sm-50"
                                />
                                <span class="d-none d-sm-inline">Песни [{{ playlistDetail.tracks.length }}]</span>
                              </template>

                              <div class="my-1 py-25">
                                <b-table
                                    ref="refTracksListTable"
                                    :items="playlistDetail.tracks"
                                    responsive
                                    :fields="tableColumns"
                                    primary-key="index"
                                    show-empty
                                    empty-text="No tracks"
                                    class="position-relative"
                                >

                                  <template #cell(row_num)="data">
                                    {{ data.index + 1 }}
                                  </template>

                                  <!-- Column: Client -->
                                  <template #cell(artists)="data">
                                  <span v-for="(artist, index) in data.item.artists">
                                    <b-link
                                        v-if="artist.id"
                                        :to="{ name: 'artist-view', params: { id: artist.id }}"
                                        class="font-weight-bold"
                                    >
                                      {{ artist.name }}
                                    </b-link>
                                    <span                                      v-else>
                                      {{ artist.name }}
                                      <template v-if="artist.name && artist.name !== '.'">
                                        <b-button
                                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                            variant="warning"
                                            class="btn-icon ml-1"
                                            size="sm"
                                            @click="addArtist(artist.name)"
                                        >
                                          <feather-icon icon="PlusIcon"/>
                                        </b-button>
                                        <b-button
                                            :to="{name: 'artists-search', query: { q: artist.name }}"
                                            variant="info"
                                            class="btn-icon ml-1"
                                            size="sm"
                                        >
                                          <feather-icon icon="SearchIcon"/>
                                        </b-button>
                                      </template>
                                    </span>
                                    <span v-if="index < data.item.artists.length - 1">, </span>
                                  </span>
                                  </template>

                                  <!-- Column: duration -->
                                  <template #cell(duration)="data">
                                  <span class="text-nowrap">
                                    {{ formatDuration(data.item.durationMs / 1000) }}
                                  </span>
                                  </template>

                                  <!-- Column: Client -->
                                  <template #cell(actions)="data">
                                  <span class="text-nowrap">
                                    <b-button
                                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                        v-if="!data.item.id"
                                        :variant="(data.item.artists && data.item.artists[0] && data.item.artists[0].id) ? 'success' : 'warning'"
                                        class="btn-icon ml-1"
                                        @click="addTrack(data.item)"
                                    >
                                      <feather-icon icon="PlusIcon"/>
                                    </b-button>
                                  </span>

                                  </template>
                                </b-table>

                              </div>
                            </b-tab>

                          </b-tabs>
                        </b-col>
                      </b-row>
                    </b-overlay>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-overlay>
        </b-col>
        <!--/ blogs -->
      </b-row>
      <!--/ blogs -->
      <b-row v-else>
        <b-col cols="12">
          <b-overlay
              :show="isLoadingPlaylist"
              rounded="sm"
          >
            <b-card
                title="Данных нет"
                class="col-md-12 col-12"
            >
              <b-card-text>
                Загрузите SIQ-файл
              </b-card-text>
            </b-card>
          </b-overlay>

        </b-col>
      </b-row>
    </div>
    <!--/ content -->

  </div>
</template>

<script>
import {
  BFormInput,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BLink,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BTab,
  BTabs,
  BSpinner,
  BOverlay,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {badWord, formatNumber, formatDate, formatDuration} from '@core/utils/filter'
import router from "@/router";
import store from "@/store";
import musicStoreModule from "@/views/db-music/musicStoreModule";
import {onUnmounted, ref} from "@vue/composition-api";
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TrackRow from "@/views/db-music/TrackRow";
import {count} from "echarts/src/component/dataZoom/history";
import {useInputImageRenderer} from "@core/comp-functions/forms/form-utils";

export default {
  components: {
    TrackRow,
    BFormInput,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BBadge,
    BCardText,
    BDropdown,
    BForm,
    BDropdownItem,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BTab,
    BTabs,
    BSpinner,
    BOverlay,
    BTable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {}
  },
  methods: {
    count,
  },
  setup() {
    const STORE_MODULE_NAME = 'playlist'
    const toast = useToast()

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, musicStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const playlistDetail = ref(null)
    const isLoadingPlaylist = ref(false)
    const playlistCacheId = ref(null)
    const refInputUploadFile = ref(null)

    // Table Handlers
    const tableColumns = [
      {key: 'row_num', label: '№', sortable: false},
      {key: 'artists', sortable: false},
      {key: 'title', sortable: true},
      {key: 'actions'},
    ]

    const fetchPlaylistData = async () => {
      if (playlistCacheId.value) {
        const res = await store.dispatch('playlist/sigameImportList', {file: null, id: playlistCacheId.value})
        playlistDetail.value = res.data
      }
    }

    const { inputImageRenderer: inputSiqFileRenderer } = useInputImageRenderer(refInputUploadFile, async base64 => {
      // eslint-disable-next-line no-param-reassign
      const file = refInputUploadFile.value.files[0]
      blockData()
      try {
        const res = await store.dispatch('playlist/sigameImportList', {file: file, id: null})
        playlistDetail.value = res.data
        playlistCacheId.value = res.data.cache_id
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error uploading SIQ file',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    })

    const addArtist = async (artist) => {
      blockData()
      try {
        await store.dispatch(`playlist/createArtist`, {title: artist})
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error adding artist',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const addTrack = async (track) => {
      let artist_id = null
      let artist_name = null
      if (track && track.artists && track.artists[0] && track.artists[0].id) {
        artist_id = track.artists[0].id
      }
      if (track && track.artists && track.artists[0] && track.artists[0].name) {
        artist_name = track.artists[0].name
      }

      blockData()

      try {
        if (!artist_id) {
          const response = await store.dispatch(`playlist/createArtist`, {title: artist_name})
          let new_artist_id = response.data.data.id
          await store.dispatch('playlist/addTrack', {id: new_artist_id, queryParams: {title: track.title}})
          refreshData()
        } else {
          await store.dispatch('playlist/addTrack', {id: artist_id, queryParams: {title: track.title}})
          refreshData()
        }
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error adding track',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const refreshData = async () => {
      blockData()
      try {
        await fetchPlaylistData()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error refreshing playlist data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const blockData = () => {
      isLoadingPlaylist.value = true
    }

    const unblockData = () => {
      isLoadingPlaylist.value = false
    }

    return {
      formatDate,
      playlistDetail,
      isLoadingPlaylist,
      refreshData,
      addArtist,
      blockData,
      unblockData,
      tableColumns,
      formatNumber,
      formatDuration,
      addTrack,
      inputSiqFileRenderer,
      refInputUploadFile,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
